import controller from "./dropdown.controller";

export default {
    controller,
    bindings: {
        align: "@?",
        arrow: "<?",
        persistent: "<?"
    }
};
